/**
 * Inline advisory shown above credential fields (PATs, API tokens, S3
 * secret keys). Reminds the user that whatever they type sits in
 * `localStorage` in plaintext — readable by any JS that runs on this
 * origin, by browser extensions with host permissions, and by anyone
 * with filesystem or DevTools access to this profile. Recommends
 * minimum-scope credentials and links to the full privacy notice.
 *
 * "Read more" opens in a new tab so the user doesn't lose their
 * in-progress credential entry, and deep-links to the Credentials
 * section of the privacy notice so they land on the relevant text.
 *
 * See `Privacy.tsx` for the long-form discussion. Keep this notice
 * short — it sits inline in a form, not on its own page.
 */

import { Icon } from './Icon.js';
import './LocalCredentialNotice.css';

export function LocalCredentialNotice(): JSX.Element {
  return (
    <div className="local-credential-notice" role="note">
      <Icon name="alert-circle" size={14} />
      <p>
        Stored unencrypted in your browser&apos;s local storage. Use a token with the minimum scope
        your workflow needs.{' '}
        <a
          className="local-credential-notice-link"
          href="/privacy#credentials"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Read more about local credential storage (opens in a new tab)"
        >
          Read more
        </a>
      </p>
    </div>
  );
}
